// extracted by mini-css-extract-plugin
module.exports = {"footer-item-hover":"footer-animation_footer-item-hover__u2Cgg"};